import React from 'react'
import { Toaster as Sonner } from 'sonner'
import { CheckCircle, XCircle, AlertCircle, Info } from 'lucide-react'

export function Toaster({ ...props }) {
  return (
    <Sonner
      position="bottom-left"
      className="toaster group"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'group toast flex items-center gap-3 w-full p-4 rounded-lg border shadow-lg backdrop-blur-sm transition-all',
          title: 'text-sm font-semibold',
          description: 'text-sm opacity-90',
          actionButton: 'ml-auto',
          cancelButton: 'ml-auto',
          closeButton: 'absolute right-2 top-2 rounded-md p-1 opacity-70 transition-opacity hover:opacity-100',
          success: 'bg-green-50 border-green-200 text-green-900 [&_svg]:text-green-600',
          error: 'bg-red-50 border-red-200 text-red-900 [&_svg]:text-red-600',
          warning: 'bg-yellow-50 border-yellow-200 text-yellow-900 [&_svg]:text-yellow-600',
          info: 'bg-purple-50 border-purple-200 text-purple-900 [&_svg]:text-purple-600',
          default: 'bg-white border-gray-200 text-gray-900'
        }
      }}
      icons={{
        success: <CheckCircle className="h-5 w-5" />,
        error: <XCircle className="h-5 w-5" />,
        warning: <AlertCircle className="h-5 w-5" />,
        info: <Info className="h-5 w-5" />
      }}
      {...props}
    />
  )
}
